import { useQuery } from '@fv/client-core'
import type { UsageStatQuery, UsageStatResult } from '@fv/models/admin'

import { adminFetchWithQueryBrackets } from '@/utils'

export const useUsageStat = (query: UsageStatQuery) =>
  useQuery(['usage-stat', query], () =>
    adminFetchWithQueryBrackets<UsageStatResult>('/usage/stat', { query }),
  )
